import { GlButton, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { launchDrawioEditor } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/drawio/drawio_editor.js?vue3';
import { create } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/drawio/markdown_field_editor_facade.js?vue3';
export default {
    name: 'DrawioToolbarButton',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        uploadsPath: {
            type: String,
            required: true
        },
        markdownPreviewPath: {
            type: String,
            required: true
        }
    },
    methods: {
        getTextArea () {
            return document.querySelector('.js-gfm-input');
        },
        launchDrawioEditor () {
            launchDrawioEditor({
                editorFacade: create({
                    uploadsPath: this.uploadsPath,
                    textArea: this.getTextArea(),
                    markdownPreviewPath: this.markdownPreviewPath
                })
            });
        }
    }
};
